export default __webpack_public_path__ + "static/media/013-traffic-sign-1.f770825c.png";